import { call, put, select } from 'redux-saga/effects';
import {
  selectIsRestreamerSession,
  selectRestreamerStatus,
  stopRestreaming,
} from 'features/restreamer/restreamerSlice';
import { RestreamerStatus } from 'features/restreamer/types';
import { logger } from 'utils/logger';
import { SignalingSocket } from 'services/signaling';

export function* stopRestreamingSaga() {
  const isRestreamerSession: boolean = yield select(selectIsRestreamerSession);
  if (isRestreamerSession) {
    yield call(SignalingSocket.send, { event: 'restreamingStopped' });
    return;
  }

  const restreamerStatus: RestreamerStatus = yield select(selectRestreamerStatus);
  if (restreamerStatus === 'stopped') {
    return;
  }

  logger.remote({ tier: 1 }).info('Restreaming stopped');

  yield put(stopRestreaming());
}
